import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { globalAuthState } from '@mindly/ui-components';

export const getAuthenticationToken = async () => {
  try {
    // Wait for auth initialization before proceeding
    await globalAuthState.waitForReady();

    const { token } = await FirebaseAuthentication.getIdToken();
    return token;
  } catch (error) {
    return null;
  }
};
